export default __webpack_public_path__ + "static/media/icon_peruskriteerit_aloittamatta.222e0ffd.svg";